import { createStrictContext } from 'utils/createContext'
import {
  useIssueDispositionTypesMetadataQuery,
  useIssueDispositionTypesQuery,
} from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useGlobalState } from 'context/GlobalStateContext'
import { IssueDispositionTypeContext } from './types'
import { useOptions } from '../../../../../../../../components/CIMSSelect/hooks/useOptions'

const { Provider, useContextFn } =
  createStrictContext<IssueDispositionTypeContext>('DispositionTypesContext')

export const useDispositionTypesContext = useContextFn

const DispositionTypesProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { data, loading, refetch } = useIssueDispositionTypesQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const metadata = useIssueDispositionTypesMetadataQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const types = useOptions({
    items: metadata.data?.project?.issueTypes,
    value: 'id',
    label: 'name',
    tooltip: 'description',
    sort: 'name',
  })
  return (
    <Provider
      value={{
        loading: loading ?? metadata.loading,
        refetch,
        dispositionTypes: data?.issueDispositionTypes?.records ?? [],
        types,
      }}
    >
      {children}
    </Provider>
  )
}

export default DispositionTypesProvider
